const UNIFORMS = {
  trimmer:     { shirt: '#3aa655', pants: '#2f5d3a', hardHat: false, tool: 'shears' },
  grower:      { shirt: '#3b82c4', pants: '#274b6b', hardHat: false, tool: 'wateringCan' },
  scientist:   { shirt: '#e8e8ef', pants: '#9aa0b5', hardHat: false, tool: 'flask' },
  maintenance: { shirt: '#d98a1f', pants: '#5a4a2a', hardHat: true,  tool: 'wrench' },
  manager:     { shirt: '#b5453f', pants: '#3a2422', hardHat: false, tool: 'clipboard' },
};
const FALLBACK = { shirt: '#9aa0aa', pants: '#5a5f66', hardHat: false, tool: null };

/** @returns {{shirt: string, pants: string, hardHat: boolean, tool: string|null}} outfit theme for a worker type */
export function workerUniform(type) {
  return UNIFORMS[type] || FALLBACK;
}
